import { buttonRecipe } from '../../design/recipes/button';
import { iconButtonRecipe } from '../../design/recipes/iconButton';
import { toMuiVariants } from '../../design/toMuiVariants';

export const getButtonsOverrides = (theme) => ({
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem",
          fontWeight: 600,
          textTransform: "none",
          lineHeight: 1,
          minHeight: "24px",
          fontFamily: '"Noto Sans", sans-serif',
        },
        sizeSmall: {
          borderRadius: "6px",
          fontSize: "0.875rem",
          padding: "0.25rem 1rem",
          minHeight: "24px",
        },
        sizeMedium: {
          borderRadius: "6px",
          fontSize: "0.875rem",
          padding: "0.5rem 1.25rem",
          minHeight: "24px",
        },
        sizeLarge: {
          borderRadius: "6px",
          fontSize: "0.875rem",
          padding: "0.75rem 1.25rem",
          minHeight: "24px",
        },
      },
      variants: [...toMuiVariants(buttonRecipe)],
    },
    MuiIconButton: {
        variants: toMuiVariants(iconButtonRecipe),
        styleOverrides: {
          root: ({ theme }) => ({
            "&:focus-visible": {
              outline: `3px solid ${theme.palette.accent?.butterscotch }`,
              outlineOffset: "2px",
            },
          }),
        },
      },
});
